import { Modal } from 'antd'
import {
  ActionWrap,
  ButtonDiv,
  ContentFlex,
  FlexWrap,
  Heading,
} from 'components/DragDiv/style'
import DeleteIcon from 'components/icons/Delete'
import EditIcon from 'components/icons/JobRoleIcons/EditPenIcon.js'
import React from 'react'
const { confirm } = Modal

const DragDiv = ({
  headingParam = 'name',
  descriptionParam = 'description',
  idParam = 'id',
  sortedItems = ['Item 1', 'Item 2', 'Item 3', 'Item 4'],
  setSortedItems,
  onEditClick,
  disabled = false,
  availableItem = [],
  disableDelete = false,
  disableEdit = false,
  round = false,
}) => {
  const SortableItem = ({ value }) => (
    <FlexWrap centerVertically>
      <ContentFlex width="85%" gap="10px" centerVertically>
        <ContentFlex column>
          <Heading>{value[headingParam]}</Heading>
          <div
            dangerouslySetInnerHTML={{ __html: value[descriptionParam] }}
          ></div>
        </ContentFlex>
      </ContentFlex>
      <ActionWrap centerVertically>
        <ButtonDiv
          onClick={() =>
            onEditClick(
              value,
              'edit',
              (disabled || disableEdit) &&
                availableItem
                  ?.map(item => item?.name)
                  ?.includes(value[headingParam])
                ? true
                : false
            )
          }
        >
          <EditIcon />
        </ButtonDiv>
        {(disabled || disableDelete || value.applied > 0) &&
        availableItem
          ?.map(item => item?.name)
          ?.includes(value[headingParam]) ? null : (
          <ButtonDiv
            onClick={() =>
              confirm({
                zIndex: '1001',
                title: `Delete ${value?.name}?`,
                okText: 'Confirm',
                okType: 'primary',
                cancelText: 'Cancel',
                onOk: () => {
                  Modal.destroyAll()
                  onEditClick(value, 'delete')
                },
              })
            }
          >
            <DeleteIcon />
          </ButtonDiv>
        )}
      </ActionWrap>
    </FlexWrap>
  )

  return (
    <>
      {sortedItems?.map((value, index) => (
        <SortableItem
          key={`item-${index + 'round'}`}
          index={index + 'round'}
          value={value}
          disabled={round == 'round' ? value?.isOngoing : disabled}
        />
      ))}
    </>
  )
}

export default DragDiv
